import { TranslationKeys } from '@/localization';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type FormFieldProps = { label: TranslationKeys; className?: string } & PropsWithChildren;

export const FormField: FC<FormFieldProps> = ({ label, className, children }) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge('grid gap-1.5 w-full', className)}>
      <label className='text-sm font-medium text-secondary-700 first-letter:capitalize'>{t(label as any)}</label>
      {children}
    </div>
  );
};
